<template>
  <div class="order-step">
    <next-prev-menu
      :disabled="false"
      :previous="false"
      title="Naar Bezorgen"
      @next-step="$router.push({ name: 'quoteOrderDeliver' })"
    ></next-prev-menu>
    <div class="card">
      <div class="card-default">
        <h3>
          Opdrachtomschrijving
        </h3>
        <div class="descr-holder">
          <p
            class="error-text pointer"
            v-if="description.length == 0 && !focus"
            @click="setFocus"
          >
            Omschrijf hier uw opdracht.
          </p>
          <textarea
            class="details-text required"
            :value="description"
            @input="updateOrder('description', $event.target.value)"
            ref="description"
            @blur="focus = false"
            @focus="focus = true"
          ></textarea>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NextPrevMenu from '@/components/NextPrevMenu.vue'
import { mapStores } from 'pinia'
import { useQuoteOrderStore } from '@/features/quoteOrder/QuoteOrder.store'
/**
 * Description component
 *
 * Properties:
 *
 * - description

 *
 */

export default {
  components: { NextPrevMenu },
  //props: ['description'],
  data() {
    return {
      focus: false
    }
  },
  methods: {
    updateOrder(key, val) {
      this.quoteOrderStore.updateOrderDetails(key, val)
    },
    setFocus() {
      this.focus = true
      this.$refs.description.focus()
    }
  },
  computed: {
    ...mapStores(useQuoteOrderStore),
    description() {
      return this.quoteOrderStore.orderDetails.description
    }
  },
  created() {}
}
</script>

<style lang="scss" scoped>
.error-text {
  position: absolute;
}

.descr-holder {
  padding-top: 9px;
  height: 400px;
  width: 100%;
}

textarea {
  width: 100%;
  height: 100%;
}
</style>
